/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Sub_AreasInputs */

const cs_property_sub_areas = /** @type {(inputs: Property_Sub_AreasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plochy`)
};

const en_property_sub_areas = /** @type {(inputs: Property_Sub_AreasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Areas`)
};

/**
* | output |
* | --- |
* | "Areas" |
*
* @param {Property_Sub_AreasInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_sub_areas = /** @type {((inputs?: Property_Sub_AreasInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Sub_AreasInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_sub_areas(inputs)
	return cs_property_sub_areas(inputs)
});